var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigPlayerBothPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    className: "roadmap-cell",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.25,
    fill: "transparent",
    stroke: "#2d30b1",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    fill: "#c70000",
    stroke: "#fff",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.6,
    cy: 9.6,
    r: 2.4,
    fill: "#2d30b1",
    stroke: "#fff",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlayerBothPair);
export default __webpack_public_path__ + "static/media/BigPlayerBothPair.f215b7f3865d29995501a4f7aaea2430.svg";
export { ForwardRef as ReactComponent };